import React from 'react';

const Footer = () => (
  <footer className="footer">
    <div className="footer__inner">
      <div className="footer__brand">
        <img src="/logo.png" alt="Monologic" />
        <p>Materializamos tus ideas digitales con tecnología de vanguardia y diseño que impacta.</p>
      </div>
      <div className="footer__col">
        <h4>SERVICIOS</h4>
        <a href="#servicios">Landing Pages</a>
        <a href="#servicios">Tiendas en Línea</a>
        <a href="#servicios">Plataformas Web</a>
        <a href="#servicios">Apps Móviles</a>
      </div>
      <div className="footer__col">
        <h4>EMPRESA</h4>
        <a href="/">Nosotros</a>
        <a href="/proyectos">Proyectos</a>
        <a href="/contacto">Contacto</a>
      </div>
      <div className="footer__col">
        <h4>CONTACTO</h4>
        <a href="mailto:contacto@monologicsolutions.com">contacto@monologicsolutions.com</a>
        <a href="tel:+523318484205">+52 33 1848 4205</a>
        <a href="tel:+523326649812">+52 33 2664 9812</a>
      </div>
    </div>
    <div className="footer__bottom">
      <span>© 2026 Monologic Solutions. Todos los derechos reservados.</span>
      <div className="footer__socials">
        <a href="#" className="footer__social" title="LinkedIn" aria-label="Síguenos en LinkedIn">in</a>
        <a href="#" className="footer__social" title="Instagram" aria-label="Síguenos en Instagram">ig</a>
        <a href="#" className="footer__social" title="Twitter" aria-label="Síguenos en X (Twitter)">X</a>
      </div>
    </div>
  </footer>
);

export default Footer;
